module.exports = __webpack_public_path__ + "img/mm-landing-banner.d88fc7b0.png";